import { useState } from "react";

import Api from "../Services/Api";

function useProvideAuth() {
	const [solUser, setUser] = useState(localStorage.getItem('solUser') ? JSON.parse(localStorage.getItem('solUser')) : null);

	async function signin(loginPayload) {
		try {	
			localStorage.setItem('token', null);
			localStorage.setItem('solUser', null);
			return Api.post({endpoint: 'login', body: loginPayload, contentType : 'application/json'})
				.then(response => {
					const token = response.data.token;
					if(token){
						localStorage.setItem('token', token);
						localStorage.setItem('solUser', JSON.stringify(response.data.user));
						setUser(response.data.user);
					}
					return {'status': response.status, 'role' : response.data.user.roles[0].name};
				})
				.catch(error => {
					console.log(error);
					setUser(null);
					return {
						'status': error.response ? error.response.status : null,
						'error': (error.response && error.response.data)? error.response.data.error : null,
					};
				});
		} catch (error) {
			console.log(error);
			setUser(null);
			return {'status': error.response ? error.response.status : null};
		}
	};

	function signout() {
		try {
			Api.get({endpoint: 'logout', contentType : 'application/json'})
				.then(response => {
					unsetUser();
					return response.status;						
				})
				.catch(error => {
					console.log(error);
					unsetUser();
					return (error.response ? error.response.status : null);				
				});
		} catch (error) {
			console.log(error);
			unsetUser();
			return (error.response ? error.response.status : null);
		}			
	};
	
	function unsetUser() {
		localStorage.removeItem('token');
		localStorage.removeItem('solUser');
		setUser(null);		
	}

	return {
		solUser,
		signin,
		signout,
	};
}

export default useProvideAuth;